import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Feedback Management for Salesforce | Canny';
const Description =
  "Track feedback on behalf of contacts in Salesforce with Canny's integration. Leverage feedback management to build features leads want and close more deals.";
const Image = 'https://canny.io/images/canny-social.png';

export default class SalesforceLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/integrations/salesforce' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
